import ReportSwitch from './ReportSwitch';

export default ReportSwitch;
